<div class="is-blocked">
  <div class="header-container">
    <cp-logo></cp-logo>
  </div>
  <div class="icon-container">
    <img src="/assets/icons/no-access.png" alt="" />
    <label for=""> You Have no Access </label>
  </div>
  <div class="description-container">
    <h1>We're quite sorry about this!</h1>
    <p>
      Your request cannot be processed at this time; the subscription plan for
      this company is expired. Please talk to your manager or try again later
    </p>
  </div>
  <div class="button-container">
    <gbui-button class="solid-buttons" (click)="logOut()">Back</gbui-button>
  </div>
</div>
